// Email domain allowlist — the organisations permitted to sign in.
//
// Shared by the Entra SSO callback (auth/entra.ts) and the public email
// sign-in (auth/email-login.ts) so the two paths cannot drift apart.

export const ALLOWED_EMAIL_DOMAINS = ['dcvfd.org', 'pwcgov.org'] as const;

/** Lowercased domain part of an email address, or null if it has no usable one. */
export function emailDomain(email: string): string | null {
  const at = email.lastIndexOf('@');
  if (at <= 0 || at === email.length - 1) return null;
  return email.slice(at + 1).toLowerCase();
}

/** True when the address belongs to an allowed organisation. */
export function isAllowedEmailDomain(email: string): boolean {
  const domain = emailDomain(email);
  return domain !== null && (ALLOWED_EMAIL_DOMAINS as readonly string[]).includes(domain);
}

/** Human-readable list for error copy, e.g. "dcvfd.org or pwcgov.org". */
export function allowedDomainsLabel(): string {
  return ALLOWED_EMAIL_DOMAINS.join(' or ');
}
